import { render, staticRenderFns } from "./CharacteristicColumnList.vue?vue&type=template&id=1e74553e&scoped=true"
import script from "./CharacteristicColumnList.vue?vue&type=script&lang=js"
export * from "./CharacteristicColumnList.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicColumnList.vue?vue&type=style&index=0&id=1e74553e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74553e",
  null
  
)

export default component.exports